import { render, staticRenderFns } from "./PromotionButton.vue?vue&type=template&id=1d83239b"
import script from "./PromotionButton.vue?vue&type=script&lang=js"
export * from "./PromotionButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports